import React, { useState, useEffect } from "react";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { Box, Flex, TextField, Text, Button, Spinner } from "@radix-ui/themes";
import CloudFunctions from "@/api/cloudFunctions/CloudFunctions";
import { toast } from "react-toastify";
import useProfileLunar from "@/features/profile/hooks/useProfileLunar";
import { Link2Icon } from "@radix-ui/react-icons";

export const ConnectRivalsAccount: React.FunctionComponent = () => {
  const currentUser = useCurrentUserProfile((s) => s.user);
  const [playerId, setPlayerId] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const { profileLunar, refetch } = useProfileLunar(currentUser.uid);

  useEffect(() => {
    if (profileLunar) {
      setPlayerId(profileLunar.mrUID);
    }
  }, [profileLunar]);

  const setRivalsPlayerId = async () => {
    setLoading(true);
    await CloudFunctions.callCloudFunction("setLunarPlayer", {
      playerId,
    })
      .then(async (response) => {
        toast.info(response.message);
        setLoading(false);
        refetch();
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.message);
        setLoading(false);
      });
  };

  return (
    <Box>
      <Flex direction="column" gap="1">
        {/* Username */}
        <Flex direction="column" gap="1">
          <Text as="label" size="2">
            Marvel Rivals Player ID
          </Text>
          <Flex align="center" gap="1">
            <TextField.Root
              size="3"
              type="text"
              value={playerId}
              onChange={(e) => {
                setPlayerId(e.target.value);
              }}
              disabled={profileLunar && profileLunar.mrUID ? true : false}
            />

            <Box>
              <Button
                variant="solid"
                onClick={() => {
                  setRivalsPlayerId();
                }}
                size="2"
                style={{ minHeight: "100%" }}
                disabled={profileLunar && profileLunar.mrUID ? true : false}
              >
                {!profileLunar && (loading ? <Spinner /> : "Connect")}
                {profileLunar && (
                  <Text style={{ textTransform: "capitalize" }}>
                    <Link2Icon /> {profileLunar.status}
                  </Text>
                )}
              </Button>
            </Box>
          </Flex>
        </Flex>
        {profileLunar && (
          <Text size="1" color="gray">
            You are linked to the Marvel Rivals account:{" "}
            {profileLunar.mrUserName}.
          </Text>
        )}
      </Flex>
    </Box>
  );
};
